import { IOrder } from 'next-common';
import { formatNumber } from 'sales-common-mapper';
import { IVehicleChargeStatus } from '../../common';
import { MessageBar } from '@repo/ui/components';
import { TMessageBarSeverity } from 'types';

export interface IOneOffTaxWarningProps {
  vehicleChargeStatus: IVehicleChargeStatus;
  order: IOrder;
}

export const OneOffTaxChangeWarning = (props: IOneOffTaxWarningProps) => {
  const formatPrice = (price: number) => (
    <span className="font-extrabold text-base/[175%]">{formatNumber(price)} kr</span>
  );

  const getWarningMessage = () => {
    const { isTaxChange, isTaxIncreased, UpdatedOneOffTax, ExistingOneOffTax } = props.vehicleChargeStatus || {
      isTaxChange: false,
      isTaxIncreased: false,
      UpdatedOneOffTax: 0,
      ExistingOneOffTax: 0,
    };

    if (!isTaxChange) return '';
    if (props.order?.isEditOrder) {
      //CASE: ORDER
      if (isTaxIncreased) {
        return (
          <>
            Engangsavgift har økt med {formatPrice(UpdatedOneOffTax - ExistingOneOffTax)} og er endret fra{' '}
            {formatPrice(ExistingOneOffTax)} til {formatPrice(UpdatedOneOffTax)}, du må lage en ny kontrakt og innhente
            signatur fra kunde. Finanstilbudene blir rekalkulert i Next når du åpner gjenopptar tilbudet. Eventuelle
            søknader i finansportalen må oppdateres.
          </>
        );
      } else {
        return (
          <>
            Engangsavgift er redusert med {formatPrice(ExistingOneOffTax - UpdatedOneOffTax)} og er endret fra
            {formatPrice(ExistingOneOffTax || 0)} til {formatPrice(UpdatedOneOffTax)}, du må lage en ny kontrakt og
            innhente signatur fra kunde. Finanstilbudene blir rekalkulert i Next når du åpner gjenopptar tilbudet.
            Eventuelle søknader i finansportalen må oppdateres.
          </>
        );
      }
    } else {
      //CASE: OFFER
      if (isTaxIncreased) {
        return (
          <>
            Engangsavgift er økt med {formatPrice(UpdatedOneOffTax - ExistingOneOffTax)} og er endret fra
            {formatPrice(ExistingOneOffTax)} til {formatPrice(UpdatedOneOffTax)}, du bør kontakte kunde og gi et
            oppdatert tilbud. Finanstilbudene blir rekalkulert i Next når du åpner gjenopptar tilbudet. Eventuelle
            søknader i finansportalen må oppdateres.
          </>
        );
      } else {
        return (
          <>
            Engangsavgift er redusert med {formatPrice(ExistingOneOffTax - UpdatedOneOffTax)} og er endret fra{' '}
            {formatPrice(ExistingOneOffTax || 0)} til {formatPrice(UpdatedOneOffTax)}, du bør kontakte kunde og gi et
            oppdatert tilbud. Finanstilbudene blir rekalkulert i Next når du åpner gjenopptar tilbudet. Eventuelle
            søknader i finansportalen må oppdateres.
          </>
        );
      }
    }
  };

  return (
    <MessageBar severity={TMessageBarSeverity.WARNING} className="py-3 px-4">
      <span className="text-base/[175%] font-semibold">{getWarningMessage()}</span>
    </MessageBar>
  );
};
